export default __webpack_public_path__ + "static/media/icone-chaveiros.7b0a91cb.png";